import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "catalogue-event-config--container"
}
const _hoisted_2 = { class: "row modal-header--container modal-header" }
const _hoisted_3 = { class: "modal-header--inner" }
const _hoisted_4 = { class: "bold" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "filter-tab-navigation" }
const _hoisted_7 = { class: "navigation-tab__title" }
const _hoisted_8 = { class: "navigation-tab__title" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "main-frame"
}
const _hoisted_11 = { class: "main-frame__left" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = {
  class: "col-12",
  style: {"padding-right":"1.2rem"}
}
const _hoisted_14 = {
  key: 0,
  class: "event-config--input-placeholder"
}
const _hoisted_15 = {
  key: 1,
  class: "event-config--wrapper"
}
const _hoisted_16 = {
  key: 0,
  class: "event-config--inner"
}
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  key: 0,
  class: "col-23 event-config--wrapper"
}
const _hoisted_19 = { class: "event-config--input-container" }
const _hoisted_20 = {
  key: 1,
  class: "col-23 event-config--wrapper"
}
const _hoisted_21 = {
  key: 0,
  class: "event-config--input-placeholder"
}
const _hoisted_22 = {
  key: 1,
  class: "event-config--input-container"
}
const _hoisted_23 = { class: "main-frame__right" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  key: 0,
  class: "main-frame"
}
const _hoisted_26 = { class: "main-frame__left" }
const _hoisted_27 = {
  key: 0,
  class: "row"
}
const _hoisted_28 = {
  class: "col-12",
  style: {"padding-right":"1.2rem"}
}
const _hoisted_29 = {
  key: 0,
  class: "event-config--input-placeholder"
}
const _hoisted_30 = {
  key: 1,
  class: "event-config--wrapper"
}
const _hoisted_31 = {
  key: 0,
  class: "event-config--inner"
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = {
  key: 0,
  class: "col-23 event-config--wrapper"
}
const _hoisted_34 = { class: "event-config--input-container" }
const _hoisted_35 = {
  key: 1,
  class: "col-23 event-config--wrapper"
}
const _hoisted_36 = {
  key: 0,
  class: "event-config--input-placeholder"
}
const _hoisted_37 = {
  key: 1,
  class: "event-config--input-container"
}
const _hoisted_38 = { class: "main-frame__right" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = {
  key: 0,
  class: "main-frame"
}
const _hoisted_41 = { class: "main-frame__left" }
const _hoisted_42 = {
  key: 0,
  class: "row"
}
const _hoisted_43 = {
  class: "col-12",
  style: {"padding-right":"1.2rem"}
}
const _hoisted_44 = {
  key: 0,
  class: "event-config--input-placeholder"
}
const _hoisted_45 = {
  key: 1,
  class: "event-config--wrapper"
}
const _hoisted_46 = {
  key: 0,
  class: "event-config--inner"
}
const _hoisted_47 = { class: "row" }
const _hoisted_48 = {
  key: 0,
  class: "col-23 event-config--wrapper"
}
const _hoisted_49 = { class: "event-config--input-container" }
const _hoisted_50 = {
  key: 1,
  class: "col-23 event-config--wrapper"
}
const _hoisted_51 = {
  key: 0,
  class: "event-config--input-placeholder"
}
const _hoisted_52 = {
  key: 1,
  class: "event-config--input-container"
}
const _hoisted_53 = { class: "main-frame__right" }
const _hoisted_54 = { class: "save-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_form_select = _resolveComponent("form-select")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_object_tree = _resolveComponent("object-tree")!
  const _component_cron_editor = _resolveComponent("cron-editor")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_ControllableView = _resolveComponent("ControllableView")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.description), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["navigation-tab", {active: _ctx.activeView === 'order'}]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeView = 'order'))
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.order_type === 'orders' || _ctx.order_type === 'order' ? 'Orders' : 'Supply Orders'), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["navigation-tab", {active: _ctx.activeView === 'product'}]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeView = 'product'))
          }, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.order_type === 'orders' || _ctx.order_type === 'order' ? 'Products' : 'Stock Items'), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["navigation-tab", {active: _ctx.activeView === 'inventory'}]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeView = 'inventory'))
          }, _cache[12] || (_cache[12] = [
            _createElementVNode("span", { class: "navigation-tab__title" }, "Inventory", -1)
          ]), 2)
        ]),
        _createVNode(_component_ControllableView, {
          modelValue: _ctx.activeView,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.activeView) = $event)),
          views: _ctx.views,
          defaultView: "order"
        }, {
          order: _withCtx(({ change }) => [
            _createElementVNode("div", _hoisted_9, [
              (_ctx.orderState.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "title" }, "Events", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderState.events, (eventKey, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "event-config--container column col-12",
                          key: `${eventKey}-${i}`
                        }, [
                          _createVNode(_component_q_expansion_item, {
                            class: "event-container",
                            onBeforeShow: ($event: any) => (_ctx.modelValue.sync[_ctx.order_type].hooks[eventKey] = _ctx.modelValue?.sync?.[_ctx.order_type]?.hooks?.[eventKey] || {})
                          }, {
                            header: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_toggle, {
                                    class: "event-toggle",
                                    modelValue: _ctx.eventSelection,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.eventSelection) = $event)),
                                    val: eventKey,
                                    dense: ""
                                  }, null, 8, ["modelValue", "val"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.format.title(eventKey)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_q_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(_ctx.ORDER_EVENT_PLACEHOLDER[eventKey]), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_section, null, {
                                    default: _withCtx(() => [
                                      (_ctx.modelValue?.sync?.[_ctx.order_type]?.hooks?.[eventKey])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                            _createElementVNode("div", _hoisted_13, [
                                              _cache[14] || (_cache[14] = _createElementVNode("h6", null, "Service", -1)),
                                              (!_ctx.modelValue?.sync?.[_ctx.order_type]?.hooks?.[eventKey]?.service)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                    _createVNode(_component_ozn_button, {
                                                      class: "minimal button-add-config",
                                                      onClick: ($event: any) => (_ctx.modelValue.sync[_ctx.order_type].hooks[eventKey].service = _ctx.serviceOptions[0])
                                                    }, {
                                                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                        _createTextVNode("+ Set custom Service")
                                                      ])),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                    _createVNode(_component_form_select, {
                                                      class: "event-config--input",
                                                      "model-value": _ctx.serviceOptions.find(o => o.value === _ctx.modelValue.sync[_ctx.order_type].hooks[eventKey].service),
                                                      "onUpdate:modelValue": e => _ctx.modelValue.sync[_ctx.order_type].hooks[eventKey].service = e.value || e,
                                                      type: "select",
                                                      options: _ctx.serviceOptions
                                                    }, null, 8, ["model-value", "onUpdate:modelValue", "options"])
                                                  ]))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["onBeforeShow"]),
                          (_ctx.modelValue?.sync?.[_ctx.order_type]?.hooks?.[eventKey])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  (_ctx.modelValue?.sync?.[_ctx.order_type]?.hooks?.[eventKey].service && _ctx.modelValue?.sync?.[_ctx.order_type]?.hooks?.[eventKey].service.value === 'http')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _cache[15] || (_cache[15] = _createElementVNode("h6", null, "URL", -1)),
                                        _createElementVNode("div", _hoisted_19, [
                                          _createVNode(_component_form_input, {
                                            class: "event-config--input",
                                            modelValue: _ctx.modelValue.sync[_ctx.order_type].hooks[eventKey].url,
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.modelValue.sync[_ctx.order_type].hooks[eventKey].url) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.modelValue?.sync?.[_ctx.order_type]?.hooks?.[eventKey].service && _ctx.modelValue?.sync?.[_ctx.order_type]?.hooks?.[eventKey].service.value === 'http')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        (!_ctx.modelValue?.sync?.[_ctx.order_type]?.hooks?.[eventKey].query)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                              _cache[17] || (_cache[17] = _createElementVNode("h6", null, "Query", -1)),
                                              _createVNode(_component_ozn_button, {
                                                class: "minimal button-add-config",
                                                onClick: ($event: any) => (_ctx.modelValue.sync[_ctx.order_type].hooks[eventKey].query = {})
                                              }, {
                                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                  _createTextVNode("+ Set Query")
                                                ])),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                              _createVNode(_component_object_tree, {
                                                modelValue: _ctx.modelValue.sync[_ctx.order_type].hooks[eventKey].query,
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.modelValue.sync[_ctx.order_type].hooks[eventKey].query) = $event),
                                                suggestions: [],
                                                header: "Query"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "title" }, "Options", -1)),
                      _createVNode(_component_cron_editor, {
                        "model-value": _ctx.modelValue?.sync[_ctx.order_type]?.trigger?.timer,
                        onSetCrontab: _ctx.toggleSync
                      }, null, 8, ["model-value", "onSetCrontab"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          product: _withCtx(({ change }) => [
            _createElementVNode("div", _hoisted_24, [
              (_ctx.productState.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "title" }, "Events", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productState.events, (eventKey, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "event-config--container column col-12",
                          key: `${eventKey}-${i}`
                        }, [
                          _createVNode(_component_q_expansion_item, { class: "event-container" }, {
                            header: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_toggle, {
                                    class: "event-toggle",
                                    modelValue: _ctx.eventSelection,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.eventSelection) = $event)),
                                    val: eventKey,
                                    dense: ""
                                  }, null, 8, ["modelValue", "val"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.format.capitalize(eventKey)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_q_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(_ctx.PRODUCT_EVENT_PLACEHOLDER[eventKey]), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_section, null, {
                                    default: _withCtx(() => [
                                      (_ctx.eventConfig?.sync?.[_ctx.product_type]?.hooks?.[eventKey])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            _createElementVNode("div", _hoisted_28, [
                                              _cache[21] || (_cache[21] = _createElementVNode("h6", null, "Service", -1)),
                                              (!_ctx.eventConfig?.sync?.[_ctx.product_type]?.hooks?.[eventKey]?.service)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                    _createVNode(_component_ozn_button, {
                                                      class: "minimal button-add-config",
                                                      onClick: ($event: any) => (_ctx.eventConfig.sync[_ctx.product_type].hooks[eventKey].service = _ctx.serviceOptions[0])
                                                    }, {
                                                      default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                        _createTextVNode("+ Set custom Service")
                                                      ])),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                    _createVNode(_component_form_select, {
                                                      class: "event-config--input",
                                                      "model-value": _ctx.eventConfig?.sync[_ctx.product_type]?.hooks?.[eventKey].service,
                                                      type: "select",
                                                      options: _ctx.serviceOptions,
                                                      "onUpdate:modelValue": e => _ctx.updateOrderEventService(eventKey, e)
                                                    }, null, 8, ["model-value", "options", "onUpdate:modelValue"])
                                                  ]))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (_ctx.eventConfig?.sync?.[_ctx.product_type]?.hooks?.[eventKey])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  (_ctx.eventConfig?.sync?.[_ctx.product_type]?.hooks?.[eventKey].service && _ctx.eventConfig?.sync?.[_ctx.product_type]?.hooks?.[eventKey].service.value === 'http')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _cache[22] || (_cache[22] = _createElementVNode("h6", null, "URL", -1)),
                                        _createElementVNode("div", _hoisted_34, [
                                          _createVNode(_component_form_input, {
                                            class: "event-config--input",
                                            modelValue: _ctx.eventConfig.sync[_ctx.product_type].hooks[eventKey].url,
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.eventConfig.sync[_ctx.product_type].hooks[eventKey].url) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.eventConfig?.sync?.[_ctx.product_type]?.hooks?.[eventKey].service && _ctx.eventConfig?.sync?.[_ctx.product_type]?.hooks?.[eventKey].service.value === 'http')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                        (!_ctx.eventConfig?.sync?.[_ctx.product_type]?.hooks?.[eventKey].query)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                              _cache[24] || (_cache[24] = _createElementVNode("h6", null, "Query", -1)),
                                              _createVNode(_component_ozn_button, {
                                                class: "minimal button-add-config",
                                                onClick: ($event: any) => (_ctx.eventConfig.sync[_ctx.product_type].hooks[eventKey].query = {})
                                              }, {
                                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                  _createTextVNode("+ Set Query")
                                                ])),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                              _createVNode(_component_object_tree, {
                                                modelValue: _ctx.eventConfig.sync[_ctx.product_type].hooks[eventKey].query,
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.eventConfig.sync[_ctx.product_type].hooks[eventKey].query) = $event),
                                                suggestions: [],
                                                header: "Query"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "title" }, "Options", -1)),
                      _createVNode(_component_cron_editor, {
                        "model-value": _ctx.eventConfig?.sync[_ctx.product_type]?.trigger?.timer,
                        onSetCrontab: _ctx.toggleSync
                      }, null, 8, ["model-value", "onSetCrontab"]),
                      _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_q_toggle, {
                        class: "space-v2",
                        dense: "",
                        "model-value": _ctx.eventConfig?.sync[_ctx.product_type]?.use_parent_sku || false,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.eventConfig.sync[_ctx.product_type].use_parent_sku = $event)),
                        label: "Use Product article number"
                      }, null, 8, ["model-value"]),
                      _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_q_toggle, {
                        class: "space-v2",
                        dense: "",
                        "model-value": _ctx.eventConfig?.sync[_ctx.product_type]?.create_parent_item || false,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.eventConfig.sync[_ctx.product_type].create_parent_item = $event)),
                        label: "Automatically create new base products"
                      }, null, 8, ["model-value"]),
                      _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                      _createVNode(_component_q_toggle, {
                        class: "space-v2",
                        dense: "",
                        "model-value": _ctx.eventConfig?.sync[_ctx.product_type]?.pricing_manager_service ? true : false,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.eventConfig.sync[_ctx.product_type].pricing_manager_service = $event)),
                        label: "Enable automic pricing by external service "
                      }, null, 8, ["model-value"]),
                      _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                      (_ctx.eventConfig?.sync?.[_ctx.product_type]?.pricing_manager_service)
                        ? (_openBlock(), _createBlock(_component_form_select, {
                            key: 0,
                            class: "col-8 q-mt-md",
                            "model-value": _ctx.pricingServices.find(service => service.value === _ctx.eventConfig?.sync[_ctx.product_type]?.pricing_manager_service) || null,
                            type: "select",
                            onSelect: _cache[8] || (_cache[8] = ($event: any) => (_ctx.eventConfig.sync[_ctx.product_type].pricing_manager_service = $event.value)),
                            label: "Pricing Services",
                            placeholder: "Choose existing pricing service",
                            options: _ctx.pricingServices
                          }, null, 8, ["model-value", "options"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          inventory: _withCtx(({ change }) => [
            _createElementVNode("div", _hoisted_39, [
              (_ctx.inventoryState.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "title" }, "Events", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inventoryState.events, (eventKey, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "event-config--container column col-12",
                          key: `${eventKey}-${i}`
                        }, [
                          _createVNode(_component_q_expansion_item, {
                            class: "event-container",
                            icon: "perm_identity",
                            label: "Account settings",
                            caption: "John Doe"
                          }, {
                            header: _withCtx(() => [
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_toggle, {
                                    class: "event-toggle",
                                    modelValue: _ctx.eventSelection,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.eventSelection) = $event)),
                                    val: eventKey,
                                    dense: ""
                                  }, null, 8, ["modelValue", "val"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_q_item_section, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.format.capitalize(eventKey)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_q_card, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_card_section, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", null, _toDisplayString(_ctx.INVENTORY_EVENT_PLACEHOLDER[eventKey]), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_q_card_section, null, {
                                    default: _withCtx(() => [
                                      (_ctx.eventConfig?.sync?.['inventory']?.hooks?.[eventKey])
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                              _cache[33] || (_cache[33] = _createElementVNode("h6", null, "Service", -1)),
                                              (!_ctx.eventConfig?.sync?.['inventory']?.hooks?.[eventKey].service)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                    _createVNode(_component_ozn_button, {
                                                      class: "minimal button-add-config",
                                                      onClick: ($event: any) => (_ctx.eventConfig.sync['inventory'].hooks[eventKey].service = _ctx.serviceOptions[0])
                                                    }, {
                                                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                                                        _createTextVNode("+ Set custom Service")
                                                      ])),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                                    _createVNode(_component_form_select, {
                                                      class: "event-config--input",
                                                      "model-value": _ctx.eventConfig?.['inventory']?.hooks?.[eventKey].service,
                                                      type: "select",
                                                      options: _ctx.serviceOptions,
                                                      "onUpdate:modelValue": e => _ctx.eventConfig.sync['inventory'].hooks[eventKey].service = e.value || e
                                                    }, null, 8, ["model-value", "options", "onUpdate:modelValue"])
                                                  ]))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          (_ctx.eventConfig?.sync?.['inventory']?.hooks?.[eventKey])
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                  (_ctx.eventConfig?.sync?.['inventory']?.hooks?.[eventKey].service && _ctx.eventConfig?.sync?.['inventory']?.hooks?.[eventKey].service.value === 'http')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                        _cache[34] || (_cache[34] = _createElementVNode("h6", null, "URL", -1)),
                                        _createElementVNode("div", _hoisted_49, [
                                          _createVNode(_component_form_input, {
                                            class: "event-config--input",
                                            modelValue: _ctx.eventConfig.sync['inventory'].hooks[eventKey].url,
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.eventConfig.sync['inventory'].hooks[eventKey].url) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.eventConfig?.sync?.['inventory']?.hooks?.[eventKey].service && _ctx.eventConfig?.sync?.['inventory']?.hooks?.[eventKey].service.value === 'http')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                        (!_ctx.eventConfig?.sync?.['inventory']?.hooks?.[eventKey].query)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                              _cache[36] || (_cache[36] = _createElementVNode("h6", null, "Query", -1)),
                                              _createVNode(_component_ozn_button, {
                                                class: "minimal button-add-config",
                                                onClick: ($event: any) => (_ctx.eventConfig.sync['inventory'].hooks[eventKey].query = {})
                                              }, {
                                                default: _withCtx(() => _cache[35] || (_cache[35] = [
                                                  _createTextVNode("+ Set Query")
                                                ])),
                                                _: 2
                                              }, 1032, ["onClick"])
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                              _createVNode(_component_object_tree, {
                                                modelValue: _ctx.eventConfig.sync['inventory'].hooks[eventKey].query,
                                                "onUpdate:modelValue": ($event: any) => ((_ctx.eventConfig.sync['inventory'].hooks[eventKey].query) = $event),
                                                suggestions: [],
                                                header: "Query"
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "title" }, "Options", -1)),
                      _createVNode(_component_cron_editor, {
                        "model-value": _ctx.eventConfig?.sync['inventory']?.trigger?.timer,
                        onSetCrontab: _ctx.toggleSync
                      }, null, 8, ["model-value", "onSetCrontab"]),
                      _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                      _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
                      _cache[41] || (_cache[41] = _createElementVNode("h6", { class: "bold" }, "Offset", -1)),
                      _cache[42] || (_cache[42] = _createElementVNode("div", { class: "subtitle" }, "Defines an amount to subtract from the synced stock count", -1)),
                      _createVNode(_component_q_input, {
                        class: "space-v2",
                        dense: "",
                        outlined: "",
                        type: "number",
                        "model-value": _ctx.eventConfig?.sync['inventory']?.offset || 0,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.eventConfig.sync['inventory'].offset = $event)),
                        style: {"max-width":"100px"}
                      }, null, 8, ["model-value"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "views"]),
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_component_q_btn, {
            unelevated: "",
            rounded: "",
            color: "primary",
            label: "Save",
            onClick: _ctx.save
          }, null, 8, ["onClick"])
        ])
      ]))
    : _createCommentVNode("", true)
}